// Tassonomia tipologia struttura: codici stabili, label localizzate via i18n (orgx.type_<code>)
export const ORG_TYPE_CODES = [
  "poliambulatorio", "centro_diagnostico", "laboratorio_analisi", "clinica", "studio_medico",
  "studio_odontoiatrico", "centro_fisioterapico", "centro_ortopedico", "farmacia",
  "negozio_sanitario", "associazione_ets", "fondazione_ente", "organizzazione_sanitaria",
  "azienda_sanitaria", "altro",
];

// Ritorna la label localizzata; per "altro" usa il testo libero; per codici legacy sconosciuti
// mostra il valore grezzo (mai "undefined") ed evita box vuoti quando il codice manca.
export function orgTypeLabel(code, t, other) {
  if (!code) return "";
  if (code === "altro") return (other && other.trim()) ? other.trim() : t("orgx.type_altro");
  const key = `orgx.type_${code}`;
  const lbl = t(key);
  return lbl === key ? code : lbl;
}
